/* FoirePrime — utility del tema. Nessuna dipendenza. */
(function () {
  'use strict';
  var S = window.FP_SETTINGS || {};

  /* ---------------------------------------------------------------
     1) Propagazione parametri di tracking sui link interni.
        Il click id arrivato da Meta/TikTok segue l'utente su tutte
        le pagine, così la landing e il checkout lo ricevono comunque.
  ---------------------------------------------------------------- */
  function trackingParams() {
    if (S.trackEnabled === false) return;
    var keys = (S.trackKeys || '').split(',').map(function (k) { return k.trim(); }).filter(Boolean);
    if (!keys.length) return;

    var url = new URLSearchParams(window.location.search);
    var store = {};

    if (S.trackPersist !== false) {
      try { store = JSON.parse(sessionStorage.getItem('fp_params') || '{}'); } catch (e) { store = {}; }
    }
    keys.forEach(function (k) { if (url.get(k)) store[k] = url.get(k); });
    if (S.trackPersist !== false) {
      try { sessionStorage.setItem('fp_params', JSON.stringify(store)); } catch (e) {}
    }
    window.FP_PARAMS = store;
    if (!Object.keys(store).length) return;

    function decorate(a) {
      if (!a.href || a.dataset.fpDone) return;
      var href;
      try { href = new URL(a.href, window.location.origin); } catch (e) { return; }
      if (href.origin !== window.location.origin) return;
      if (/^(mailto|tel|javascript):/i.test(a.getAttribute('href') || '')) return;
      Object.keys(store).forEach(function (k) {
        if (!href.searchParams.has(k)) href.searchParams.set(k, store[k]);
      });
      a.href = href.toString();
      a.dataset.fpDone = '1';
    }
    document.querySelectorAll('a[href]').forEach(decorate);

    // link aggiunti dopo (drawer carrello, quick view, sezioni app)
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'A') decorate(n);
          if (n.querySelectorAll) n.querySelectorAll('a[href]').forEach(decorate);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    // e nei form (checkout compreso)
    document.querySelectorAll('form').forEach(function (f) {
      Object.keys(store).forEach(function (k) {
        if (f.querySelector('[name="' + k + '"]')) return;
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = k; i.value = store[k];
        f.appendChild(i);
      });
    });
  }

  /* ---------------------------------------------------------------
     2) Countdown
  ---------------------------------------------------------------- */
  function countdowns() {
    document.querySelectorAll('[data-fp-countdown]').forEach(function (el) {
      var mode = el.dataset.fpCountdown; // 'date' | 'evergreen'
      var target;

      if (mode === 'evergreen') {
        var mins = parseInt(el.dataset.minutes || '20', 10);
        var key = 'fp_cd_' + (el.dataset.key || 'default');
        var saved = null;
        try { saved = localStorage.getItem(key); } catch (e) {}
        if (!saved) {
          saved = String(Date.now() + mins * 60000);
          try { localStorage.setItem(key, saved); } catch (e) {}
        }
        target = parseInt(saved, 10);
      } else {
        target = new Date(el.dataset.date).getTime();
        if (isNaN(target)) return;
      }

      var out = el.querySelector('[data-fp-cd-out]') || el;
      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (el.dataset.onEnd === 'hide') { el.hidden = true; }
          else if (mode === 'evergreen') {
            try { localStorage.removeItem('fp_cd_' + (el.dataset.key || 'default')); } catch (e) {}
          }
          out.innerHTML = '<b>00</b><b>00</b><b>00</b>';
          clearInterval(id);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor(diff / 3600000) % 24;
        var m = Math.floor(diff / 60000) % 60;
        var s = Math.floor(diff / 1000) % 60;
        var parts = d > 0 ? [[d, el.dataset.lD || 'j'], [h, el.dataset.lH || 'h'], [m, el.dataset.lM || 'min'], [s, el.dataset.lS || 's']]
                          : [[h, el.dataset.lH || 'h'], [m, el.dataset.lM || 'min'], [s, el.dataset.lS || 's']];
        out.innerHTML = parts.map(function (p) {
          return '<b>' + pad(p[0]) + '<i>' + p[1] + '</i></b>';
        }).join('');
      }
      tick();
      var id = setInterval(tick, 1000);
    });
  }

  /* ---------------------------------------------------------------
     3) Sticky add-to-cart
  ---------------------------------------------------------------- */
  function stickyAtc() {
    var bar = document.querySelector('[data-fp-sticky-atc]');
    if (!bar) return;
    var anchor = document.querySelector('product-form') || document.querySelector('.product-form') || document.querySelector('form[data-fp-cod]');
    if (!anchor) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { rootMargin: '0px 0px -100% 0px' }).observe(anchor);

    bar.querySelectorAll('[data-fp-sticky-buy]').forEach(function (btn) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (anchor.matches('form[data-fp-cod]')) {
          var first = anchor.querySelector('input[name="name"], input, select');
          if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
          return;
        }
        var real = anchor.querySelector('[type="submit"]');
        if (real) real.click();
      });
    });
  }

  /* ---------------------------------------------------------------
     4) Offer tiers — selezione quantità/variante a scaglioni
  ---------------------------------------------------------------- */
  function tiers() {
    document.querySelectorAll('[data-fp-tiers]').forEach(function (group) {
      var form = group.closest('form') || document.querySelector(group.dataset.fpTiers) || document;
      group.addEventListener('change', function (e) {
        var input = e.target.closest('input[type="radio"]');
        if (!input) return;
        var qty = form.querySelector('input[name="quantity"]');
        var id = form.querySelector('input[name="id"], select[name="id"]');
        if (qty && input.dataset.qty) qty.value = input.dataset.qty;
        if (id && input.dataset.variant) id.value = input.dataset.variant;
        group.dispatchEvent(new CustomEvent('fp:tier', { bubbles: true, detail: input.dataset }));
      });
    });
  }

  /* ---------------------------------------------------------------
     5) Form COD
        Con endpoint  -> POST JSON all'endpoint (Make.com, FlamyFox, ecc).
        Senza endpoint -> aggiunge al carrello con gli attributi cliente
                          e manda al checkout.
  ---------------------------------------------------------------- */
  function codForms() {
    document.querySelectorAll('form[data-fp-cod]').forEach(function (form) {
      var status = form.querySelector('[data-fp-cod-status]');
      var btn = form.querySelector('[type="submit"]');
      var busy = false;

      function say(msg, type) {
        if (!status) return;
        status.hidden = false;
        status.className = 'fp-status fp-status--' + (type || 'error');
        status.textContent = msg;
      }
      function clearErr() {
        form.querySelectorAll('.field--error').forEach(function (f) { f.classList.remove('field--error'); });
        if (status) status.hidden = true;
      }
      function fail(input, msg) {
        var w = input.closest('.field') || input.parentElement;
        if (w) w.classList.add('field--error');
        say(msg, 'error');
        input.focus();
        return false;
      }

      function validate() {
        clearErr();
        var reqs = form.querySelectorAll('[required]');
        for (var i = 0; i < reqs.length; i++) {
          var el = reqs[i];
          if (!el.value.trim()) return fail(el, form.dataset.msgRequired || 'Merci de remplir tous les champs obligatoires.');
          if (el.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(el.value)) return fail(el, form.dataset.msgEmail || 'Adresse e-mail invalide.');
          if (el.name === 'phone' && form.dataset.phonePattern) {
            try {
              if (!new RegExp(form.dataset.phonePattern).test(el.value.trim())) return fail(el, form.dataset.msgPhone || 'Numéro de téléphone invalide.');
            } catch (e) {}
          }
        }
        return true;
      }

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (busy || !validate()) return;
        busy = true;
        if (btn) { btn.dataset.label = btn.textContent; btn.textContent = form.dataset.msgSending || '...'; btn.disabled = true; }

        var data = {};
        new FormData(form).forEach(function (v, k) { data[k] = v; });
        Object.assign(data, window.FP_PARAMS || {});
        data.page_url = window.location.href;
        data.referrer = document.referrer;

        var endpoint = form.dataset.endpoint || S.codEndpoint || '';

        function done(ok, msg) {
          busy = false;
          if (btn) { btn.textContent = btn.dataset.label; btn.disabled = false; }
          if (ok) {
            form.dispatchEvent(new CustomEvent('fp:cod:success', { bubbles: true, detail: data }));
            if (form.dataset.redirect) { window.location.href = form.dataset.redirect; return; }
            say(msg || form.dataset.msgSuccess || 'Commande enregistrée. Nous vous appelons pour confirmer.', 'success');
            form.reset();
          } else {
            say(msg || form.dataset.msgError || 'Une erreur est survenue. Merci de réessayer.', 'error');
          }
        }

        if (endpoint) {
          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
          }).then(function (r) { done(r.ok); }).catch(function () { done(false); });
        } else {
          // fallback: carrello Shopify + checkout
          var body = {
            items: [{ id: Number(data.id), quantity: Number(data.quantity || 1) }],
            attributes: {
              'COD - Nom': data.name || '',
              'COD - Téléphone': data.phone || '',
              'COD - Adresse': data.address || '',
              'COD - Ville': data.city || '',
              'COD - Code postal': data.zip || '',
              'COD - Pays': data.country || '',
              'COD - Note': data.note || ''
            }
          };
          Object.keys(window.FP_PARAMS || {}).forEach(function (k) { body.attributes[k] = window.FP_PARAMS[k]; });
          fetch(window.routes.cart_add_url + '.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
          }).then(function (r) {
            if (!r.ok) throw new Error();
            window.location.href = form.dataset.redirect || '/checkout';
          }).catch(function () { done(false); });
        }
      });
    });
  }


  /* ---------------------------------------------------------------
     6) Checkout esterno — porting del sistema del vecchio tema.

        - link per variante, con ripiego sul link di prodotto
        - URL normalizzato: &amp;, https:// mancante, apici e [ "..." ]
        - query string mai riscritta: il link CPA passa com'e'
        - accodati variant_id, sku, option1, option2, option3
        - accodati i parametri di tracking se attivi
        - href riscritto a ogni cambio variante e appena prima del click
  ---------------------------------------------------------------- */
  /* LeadX: completa i parametri che l'offerta vuole, solo quelli che mancano nel link */
  function fpLeadx(base, q, title, img) {
    q = q || []; var out = [];
    var hosts = String(S.leadxHosts || 'borner.click').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
    var host = ''; try { host = new URL(base, location.href).hostname.toLowerCase(); } catch (e) {}
    if (!S.leadx || S.leadx === 'off' || !hosts.some(function (h) { return host === h || host.slice(-(h.length + 1)) === '.' + h; })) return out;
    var has = function (k) { return new RegExp('[?&]' + k + '=').test(base) || q.concat(out).some(function (x) { return x.indexOf(k + '=') === 0; }); };
    var enc = function (v) { return encodeURIComponent(v).replace(/%20/g, '+'); };
    title = String(title || ''); img = String(img || '');
    if (S.leadx === 'tiktok') {
      if (title && !has('subid4')) out.push('subid4=' + enc(title));
      if (img && !has('utm_medium')) out.push('utm_medium=' + encodeURIComponent(img));
      if (S.ttPixel && !has('utm_term')) out.push('utm_term=' + encodeURIComponent(S.ttPixel));
    } else if (S.leadx === 'facebook') {
      if (title && !has('subid4')) out.push('subid4=' + enc(title) + '___' + encodeURIComponent(encodeURIComponent(img)));
    }
    return out;
  }
  /* sulle pagine bianche: ogni link scritto a mano verso l'offerta viene completato */
  function leadxLinks() {
    var P = window.FP_PRODUCT || {};
    document.querySelectorAll('a[href]:not([data-fp-ext-checkout])').forEach(function (a) {
      var h = a.getAttribute('href') || ''; if (!/^https?:/i.test(h) || a.dataset.fpLx) return;
      var add = fpLeadx(h, [], P.title, P.image); if (!add.length) return;
      var hash = ''; var i = h.indexOf('#'); if (i >= 0) { hash = h.slice(i); h = h.slice(0, i); }
      a.setAttribute('href', h + (h.indexOf('?') === -1 ? '?' : '&') + add.join('&') + hash); a.dataset.fpLx = '1';
      a.addEventListener('click', function () {
        var id = fpEvId('atc'), p = { content_type: 'product', content_name: String(P.title || '') };
        try { if (typeof ttq !== 'undefined' && ttq.track) ttq.track('AddToCart', p, { event_id: id }); } catch (e) {}
        try { if (typeof fbq === 'function') fbq('track', 'AddToCart', p, { eventID: id }); } catch (e) {}
        fpServer('AddToCart', id, String(P.title || ''));
      });
    });
  }

  /* ---------------------------------------------------------------
     Eventi dal server: lo stesso evento (stesso ID) parte anche dal
     nostro server con l'Events API. Il token sta lì, mai nel tema.
  ---------------------------------------------------------------- */
  function fpEvId(n) { return n + '_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }
  function fpCk(n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function fpServer(n, id, cn) {
    if (S.srv === false || !S.srvUrl || !S.ttPixel) return;
    var P = window.FP_PARAMS || {}, q = new URLSearchParams(location.search);
    var b = JSON.stringify({ n: n, id: id, url: location.href.split('#')[0], tt: [S.ttPixel], cn: cn || '',
      ck: { ttclid: q.get('ttclid') || P.ttclid || '', ttp: fpCk('_ttp'), fbp: fpCk('_fbp'), fbc: fpCk('_fbc') } });
    try { if (!(navigator.sendBeacon && navigator.sendBeacon(S.srvUrl, new Blob([b], { type: 'text/plain' })))) fetch(S.srvUrl, { method: 'POST', body: b, keepalive: true, mode: 'no-cors' }); } catch (e) {}
  }

  function externalCheckout() {
    var mapEl = document.querySelector('script[data-fp-ext-map]');
    var buttons = document.querySelectorAll('a[data-fp-ext-checkout]');
    if (!mapEl) return;

    var data;
    try { data = JSON.parse(mapEl.textContent); } catch (e) { return; }
    if (!mapEl.dataset.fpVc) { mapEl.dataset.fpVc = '1';
    // la scheda prodotto vista: ViewContent con ID, anche dal server
    (function () {
      var id = fpEvId('vc'), p = { content_type: 'product', content_name: String(data.title || '') };
      try { if (typeof ttq !== 'undefined' && ttq.track) ttq.track('ViewContent', p, { event_id: id }); } catch (e) {}
      try { if (typeof fbq === 'function') fbq('track', 'ViewContent', p, { eventID: id }); } catch (e) {}
      fpServer('ViewContent', id, String(data.title || ''));
    })();

    }
    if (!buttons.length) return;

    var productUrl = data.productUrl || '';
    var manual = data.manual || '';
    var byVariant = data.byVariant || {};
    var variants = data.variants || [];

    // Ripulisce l'URL senza alterarne il contenuto.
    function normalizeBase(u) {
      if (u == null) return '';
      var s = String(u).trim();
      s = s.replace(/^\s*\[\s*"?|"?\s*\]\s*$/g, '').replace(/^"+|"+$/g, '');
      s = s.replace(/&amp;/g, '&');
      if (/^\/\//.test(s)) s = 'https:' + s;
      if (s && !/^https?:\/\//i.test(s)) s = 'https://' + s.replace(/^\/+/, '');

      // la query string non si tocca: i link CPA vanno passati com'erano
      return s;
    }

    function formEncode(v) { return encodeURIComponent(v).replace(/%20/g, '+'); }

    function currentVariantId() {
      var input = document.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"], select[name="id"]');
      if (input && input.value) return String(input.value);
      var q = new URLSearchParams(window.location.search).get('variant');
      return q ? String(q) : (variants[0] ? String(variants[0].id) : null);
    }

    function variantById(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return variants[0] || null;
    }

    function baseFor(v) {
      if (manual) return manual;
      var direct = v ? byVariant[String(v.id)] : null;
      return (direct && String(direct).trim()) ? direct : (productUrl || '');
    }

    function buildUrl(base, v) {
      base = normalizeBase(base);
      if (!base) return '';

      var hash = '';
      var h = base.indexOf('#');
      if (h >= 0) { hash = base.slice(h); base = base.slice(0, h); }

      var q = [];

      // dati della variante: solo se richiesto nelle impostazioni del tema
      if (S.extAppendVariant === true && v) {
        if (v.id) q.push('variant_id=' + formEncode(String(v.id)));
        if (v.sku) q.push('sku=' + formEncode(v.sku));
        if (v.option1) q.push('option1=' + formEncode(v.option1));
        if (v.option2) q.push('option2=' + formEncode(v.option2));
        if (v.option3) q.push('option3=' + formEncode(v.option3));
      }

      // parametri di tracking dell'annuncio: solo se richiesto
      if (S.extAppend === true) {
        var store = window.FP_PARAMS || {};
        Object.keys(store).forEach(function (k) {
          if (base.indexOf(k + '=') === -1) q.push(k + '=' + formEncode(store[k]));
        });
      }

      q = q.concat(fpLeadx(base, q, data.title, data.image));

      var sep = base.indexOf('?') === -1 ? '?' : '&';
      return base + (q.length ? sep + q.join('&') : '') + hash;
    }

    function updateHref() {
      var v = variantById(currentVariantId());
      var href = buildUrl(baseFor(v), v);
      document.querySelectorAll('a[data-fp-ext-checkout]').forEach(function (a) {
        if (!href) {
          a.setAttribute('href', '#');
          a.setAttribute('aria-disabled', 'true');
        } else {
          a.removeAttribute('aria-disabled');
          a.setAttribute('href', href);
        }
      });
    }

    updateHref();

    // Dawn pubblica il cambio variante sul suo bus interno
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(updateHref, 0); }); } catch (e) {}
    }
    ['variant:change', 'product:change', 'variantChange'].forEach(function (ev) {
      document.addEventListener(ev, updateHref);
    });
    document.addEventListener('change', function (e) {
      if (e.target.closest('variant-selects, variant-radios, .product-form__input, select[name="id"]')) {
        setTimeout(updateHref, 60);
      }
    });
    window.addEventListener('popstate', function () { setTimeout(updateHref, 60); });

    /* -------------------------------------------------------------
       Al click: registriamo un Aggiungi al carrello, così i pixel
       Meta e TikTok ricevono l'evento AddToCart, poi mandiamo
       l'utente al checkout esterno.
    ------------------------------------------------------------- */
    function firePixels(v) {
      if (S.extFirePixels === false) return;
      var payload = {
        content_type: 'product',
        content_ids: v && v.id ? [String(v.id)] : [],
        contents: v && v.id ? [{ id: String(v.id), quantity: 1 }] : [],
        content_name: String(data.title || '')
      };
      var id = fpEvId('atc');
      try { if (typeof fbq === 'function') fbq('track', 'AddToCart', payload, { eventID: id }); } catch (e) {}
      try { if (typeof ttq !== 'undefined' && ttq.track) ttq.track('AddToCart', payload, { event_id: id }); } catch (e) {}
      fpServer('AddToCart', id, String(data.title || ''));
      try {
        if (window.dataLayer && window.dataLayer.push) {
          window.dataLayer.push({ event: 'add_to_cart', items: payload.contents });
        }
      } catch (e) {}
    }

    function registerAddToCart(v) {
      firePixels(v);
      if (S.extFireAtc === false) return Promise.resolve();
      if (!v || !v.id || !window.routes || !window.routes.cart_add_url) return Promise.resolve();

      var body = { items: [{ id: Number(v.id), quantity: 1 }] };
      var store = window.FP_PARAMS || {};
      if (Object.keys(store).length) {
        body.attributes = {};
        Object.keys(store).forEach(function (k) { body.attributes[k] = store[k]; });
      }

      return fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true
      }).then(function () {
        if (S.extClearCart !== true) return;
        return fetch('/cart/clear.js', { method: 'POST', keepalive: true });
      }).catch(function () {});
    }

    function onBuyClick(e) {
      var a = e.currentTarget;
      updateHref();
      var v = variantById(currentVariantId());
      var href = a.getAttribute('href');
      if (!href || href === '#') return;

      // nuova scheda: la pagina resta viva, l'evento parte con calma
      if (a.target === '_blank' || S.extNewTab === true) {
        registerAddToCart(v);
        return;
      }

      // stessa scheda: aspettiamo l'evento, poi navighiamo
      e.preventDefault();
      var done = false;
      function go() {
        if (done) return;
        done = true;
        window.location.href = href;
      }
      registerAddToCart(v).then(go);
      setTimeout(go, 700);
    }

    function bind(a) {
      if (a.dataset.fpBound) return;
      a.dataset.fpBound = '1';
      a.addEventListener('mouseenter', updateHref, { passive: true });
      a.addEventListener('touchstart', updateHref, { passive: true });
      a.addEventListener('click', onBuyClick);
    }
    document.querySelectorAll('a[data-fp-ext-checkout]').forEach(bind);

    // se il tema rimpiazza il DOM della scheda prodotto, riaggancio
    new MutationObserver(function () {
      var fresh = document.querySelectorAll('a[data-fp-ext-checkout]:not([data-fp-bound])');
      if (fresh.length) {
        fresh.forEach(bind);
        updateHref();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() { trackingParams(); countdowns(); stickyAtc(); tiers(); codForms(); externalCheckout(); leadxLinks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
